<template>
    <div :class="isTicketInfoShow?'cant-Scroll':''">
        
        <header class="lmy-header lmy-header-w">
            <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
        	{{ticketDetails.ProductName}}
    	</header>
        <div class="lmy-reservation-order" >
            <div class="order-content">
                <div class="order-s-title">
                    {{ticketBookInfo.Name}}
                    <span class="order-s-info-btn" @click="isTicketInfoShow=true">预订须知 >></span>
                </div>
                <div class="order-s-title">
                    游玩日期：{{ticketSelect.Date}}
                </div>
                <div class="order-s-title">
                    价格：￥{{ticketSelect.Price}}
                </div>

            </div>

            
           
            <div class="people-info" v-for="Group in Groups">
                <div class="order-s-title">
                    购买数量
                    <span class="order-max-num" v-if="ticketSelect">
                        限购5份
                    </span>
                    <div class="count-box">
                        <div class="sub" @click="minus">-</div>
                        <div class="count">{{stock}}</div>
                        <div class="add" @click="plus">+</div>
                    </div>
                </div>
                <!-- <div class="info-title" style="text-align: center;font-weight: bold;">
                    填写订单信息
                </div> -->
                <!-- <div class="room-people-toast"> ' * ' 符号为必填信息</div> -->
                <div v-for="(G,index) in Group">
                    <div class="info-title" style="margin-top:0.3rem;color:#c8a973">填写{{G.GroupName}} {{index>0?index:''}}</div>
                    <div v-for="I in G.Items">
                        <div class="info-item" v-show="I.Type==1">
                            <div class="item-label"><span v-if="I.IsRequired" style="color:red">* </span>姓名</div>
                            <div class="item-body">
                                <input type="text" placeholder="需与证件保持一致" v-model="I.Value">
                            </div>
                        </div>
                        <div class="info-item" v-show="I.Type==2">
                            <div class="item-label"><span v-if="I.IsRequired" style="color:red">* </span>EnName</div>
                            <div class="item-body">
                                <input type="text" placeholder="Be consistent with the certificate" v-model="I.Value">
                            </div>
                        </div>
                        <div class="info-item" v-show="I.Type==3">
                            <div class="item-label"><span v-if="I.IsRequired" style="color:red">* </span>手机号</div>
                            <div class="item-body">
                                <input type="text" placeholder="接收取票短信凭证" v-model="I.Value">
                            </div>
                        </div>
                        <div class="info-item" v-show="I.Type==4">
                            <div class="item-label"><span v-if="I.IsRequired" style="color:red">* </span>E-mail</div>
                            <div class="item-body">
                                <input type="text" placeholder="邮箱地址" v-model="I.Value">
                            </div>
                        </div>
                        <div class="info-item" v-show="I.Type==5">
                            <div class="item-label"><span v-if="I.IsRequired" style="color:red">* </span>证件类型</div>
                            <div class="item-body">
                                <select name="身份证" v-model="I.SelectedItem">
                                    <option v-for="S in I.Source" :value="S">{{S.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="info-item" v-show="I.Type==5">
                            <div class="item-label"><span v-if="I.IsRequired" style="color:red">* </span>证件号码</div>
                            <div class="item-body">
                                <input type="text" placeholder="用于景区入园等凭证" v-model="I.Value">
                            </div>
                        </div>
                        <div class="info-item" v-show="I.Type==6">
                            <div class="item-label"><span v-if="I.IsRequired" style="color:red">* </span>收件地址</div>
                            <div class="item-body">
                                <input type="text" placeholder="请填写详细收件地址" v-model="I.Value">
                            </div>
                        </div>
                        <div class="info-item" v-show="I.Type==7">
                            <div class="item-label"><span v-if="I.IsRequired" style="color:red">* </span>邮政编码</div>
                            <div class="item-body">
                                <input type="text" placeholder="收件地址邮政编码" v-model="I.Value">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
            <div class="order-btn" >
                <div v-if="ticketSelect.Price">应付：<label class="price">¥ <span class="num">{{ticketSelect.Price*stock}}</span></label></div>
                <div class="submit-btn" @click="create" v-if="ticketSelect">去支付</div>
            </div>
        </div>
        <div class="book-comfirming" v-if="isSubmit">
		    <div class='f-modal' >
	            <div class='f-modal-head'>提示</div>
	            <div class='f-modal-body'>
	                <p>正在提交订单，请稍候...</p>
	            </div>
	        </div>
	    </div>
        <TicketInfo v-show="isTicketInfoShow" :vdata="ticketBookInfo.Desc" @close="isTicketInfoShow=false"> </TicketInfo>
        
    </div>
</template>
<script>
    import ticketInfo from './../ticketInfo.vue'//预订需知
    export default{
        name:"ticket-book",
        components:{
            TicketInfo:ticketInfo,
        },
        data(){
            return{
                ticketDetails:JSON.parse(this.dao.get('ticketDetails'))||'',
                ticketBookInfo:JSON.parse(this.dao.get('ticketBookInfo'))||'',
                ticketSelect:JSON.parse(this.dao.get('ticketSelect'))||'',
                stock:1,
                Groups:[],
                dailyData:[],
                isDailyDataShow:false,
                isTicketInfoShow:false,
                isOnlyOneNeed:false,
                isSubmit:false,//是否正在提交订单
                guestItem:{},
                contItem:{},
                Desc:'',
                flag:false
            }
        },

        methods:{
            getRequirement(){
                var that = this
                var params = {
                    SupFlag:that.ticketDetails.SupFlag,
                    ProductID: that.ticketDetails.ProductID,
                    SKUID:that.ticketBookInfo.ID
                }
                that.postRequest({
                    url: that.Api.getOnlineRequirement,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        this.Groups.push(res.Result.Groups)
                        this.Desc = res.Result.Desc
                        this.guestItem = this.Groups[0][1]
                        this.contItem = this.Groups[0][0]
                        console.log(this.guestItem ,this.contItem)
                        
                    } else {
                        this.error({title: '提示', content: '门票已售罄！请选择其他套餐'});
                        window.history.go(-1)
                    }

                });
            },


            //票数减1
            minus(){
                if(this.stock==1||!this.ticketSelect)return;
                if(this.contItem&&this.contItem.ByCount){
                  this.Groups[0].pop();  
                }
                if(this.guestItem&&this.guestItem.ByCount){
                  this.Groups[0].pop();  
                }
                this.stock-=1;
            },
             //票数加1
            plus(){
                if(this.stock>=5){
                    this.error({title: '提示', content: '已超出可购买数量'});
                    return
                }
                if(this.contItem&&this.contItem.ByCount){
                    this.Groups[0].push(this.contItem)
                }
                if(this.guestItem&&this.guestItem.ByCount){
                    this.Groups[0].push(this.guestItem)
                }
                this.stock+=1;
            
            },
            //获取天数差
            getDaysSize(s2){
                var s1 = new Date(this.getDate(0));
                var s2 = new Date(s2);

                var days = s2.getTime() - s1.getTime();
                var time = parseInt(days / (1000 * 60 * 60 * 24));
                return time;
            },
            //门票可订检查
            checkBookAble() {
                var that = this;
                that.flag = false
                var item = that.ticketSelect
                var date = new Date(item.Date)
                date = new Date(date.setDate(date.getDate()+1))
                var CheckOut = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
                var param = {
                    Token: item.Token,
                    Count:that.stock,
                    CheckIn:item.Date,
                    CheckOut:CheckOut,
                };
                that.postRequest({
                    url: that.Api.getOnlineCheck,
                    params: param
                    }).then(res => {
                    if (res.IsSuccess) {
                        that.flag = true
                        that.dao.set(
                        "ticketBookInfo",
                        JSON.stringify(this.ticketBookInfo)
                        );
                    } else {
                        that.error({ title: "提示", content: res.Msg || "不能预订" });
                    }
                });
            },
            isPhoneAvailable (pone) {
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(pone)) {
                    return false;
                } else {
                    return true;
                }
            },
            //门票下单
            create(){
                var that = this;
                that.checkBookAble()
                if(that.flag)return;

                that.isSubmit = true;
                var data = JSON.parse(JSON.stringify(that.Groups[0]))
                var SFreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
                for(let item = 0;item<data.length;item++){
                    for(let i= 0;i<data[item].Items.length;i++){
                        if(data[item].Items[i].IsRequired&&!data[item].Items[i].Value){
                            that.isSubmit = false;
                            that.$alert(data[item].GroupName +'的'+  data[item].Items[i].ItemName+'为必填信息！');
                            return;
                        }
                        else if(data[item].Items[i].Type == 3&&data[item].Items[i].Value&&!that.isPhoneAvailable(data[item].Items[i].Value)){
                            that.isSubmit = false;
                            that.$alert("请填写正确格式的手机号码！");
                            return;
                        }else if(data[item].Items[i].Type == 4&&data[item].Items[i].Value&&!reg.test(data[item].Items[i].Value)){
                            that.isSubmit = false;
                            this.$alert('邮箱地址格式错误！')
                            return; 
                        }else if(data[item].Items[i].Type == 5&&data[item].Items[i].SelectedItem.Value=='ID_CARD'&&data[item].Items[i].Value&&!SFreg.test(data[item].Items[i].Value)){
                            that.isSubmit = false;
                            this.$alert('身份证格式错误！')
                            return; 
                        }
                    }
                }
                var requirement = {
                    Groups:that.Groups[0]
                }
                var param = {
                    Count: that.stock,
                    Token: that.ticketSelect.Token,
                    Requirement: requirement
                };
                that.postRequest({
                    url: that.Api.getOnlineCreate,
                    params: JSON.stringify(param)
                    }).then(res => {
                    that.isSubmit = false;
                    if (res.IsSuccess) {
                        that.OrderNO = res.Result.MainOrderID;
                        that.dao.set('thisBookingOrderNO',that.OrderNO);
                        that.$router.push({ path: '/wxPay',query:{OrderNO:that.OrderNO}});
                    } else {
                        this.error({ title: "提示", content: res.Msg || "订单创建失败，请重试！" });
                    }
                });
            },

        },
        mounted(){
            this.getRequirement()
        }
    }
</script>
















// WEBPACK FOOTER //
// src/components/ticket/book/book.vue